import { render, staticRenderFns } from "./HistoryView.vue?vue&type=template&id=cdf23d20"
import script from "./HistoryView.vue?vue&type=script&lang=js"
export * from "./HistoryView.vue?vue&type=script&lang=js"
import style0 from "./HistoryView.vue?vue&type=style&index=0&id=cdf23d20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports